import { Capacitor } from '@capacitor/core'
import { useMemo } from 'react'

type Platform = 'ios' | 'android' | 'web'

/**
 * @deprecated use useIsPlatform hook instead
 */
export const isPlatform = (platformUsed: Platform): boolean => {
  const platform = Capacitor.getPlatform()

  return platform === platformUsed
}

export const useIsPlatform = (platformUsed: Platform): boolean => {
  const isPlatform = useMemo(() => {
    return platformUsed === Capacitor.getPlatform()
  }, [platformUsed])

  return isPlatform
}
